import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'ui-push-block-links',
  exportAs: 'uiPushBlockLinks',
})
export class UiPushBlockLinksDirective {
  @HostBinding('class') class = 'ui-push-block-links';
}
